import React, { useState } from "react";
import style from "./QuestZhuguan.module.scss";
import { Empty, InputNumber, Input } from "antd";
import { handleScore } from "utils/common";
import classNames from "classnames";

interface QuestZhuguanProps {
    index: number;
    trunk: string;
    score: string;
    topicId: number;
    markScore: string;
    contentText: string;
    comment?: string | null;
    answers: {
        answerId: number;
        content: string;
        isRight: "0" | "1";
        isChoose: "0" | "1";
        stuAnswer: string;
    }[];
    onChange: (score: number, topicId: number, comment: string) => void;
    haveComment?: boolean;
}

export default function QuestZhuguan({
    haveComment = true,
    ...props
}: QuestZhuguanProps) {
    const [score, setScore] = useState(parseFloat(props.markScore) || 0);
    const [comment, setComment] = useState(
        !!props.comment ? props.comment : ""
    );
    const referenceText =
        props.answers && props.answers[0] && props.answers[0].content
            ? props.answers[0].content
            : "";

    const resultScore = handleScore(parseFloat(props.score), score);

    function onCommentsChange(e: React.ChangeEvent<HTMLTextAreaElement>) {
        setComment(e.target.value);
        props.onChange(score, props.topicId, e.target.value);
    }

    const onChangeScoreAndComment = (score: number) => {
        props.onChange(score, props.topicId, comment);
    };

    return (
        <div className={style.root}>
            <div className={style.header}>
                <h1
                    className={style.title}
                    dangerouslySetInnerHTML={{ __html: props.trunk }}
                />
                <p className={style.info}>本题 {props.score} 分</p>
            </div>
            {props.contentText && (
                <div
                    className={`${style.content} ${style.borderBottom} `}
                    dangerouslySetInnerHTML={{ __html: props.contentText }}
                />
            )}
            {props.answers.map(item => (
                <div
                    key={item.answerId}
                    className={classNames(style.content, "globalISROOTS")}
                    dangerouslySetInnerHTML={{
                        __html: item.stuAnswer?.split("</a>")?.join("</a><br/>")
                    }}
                />
            ))}
            {(props.answers.length === 0 || !props.answers[0].stuAnswer) && (
                <Empty
                    style={{ padding: 20 }}
                    className="globalISROOTS"
                    description={"学员未作答"}
                />
            )}
            <div className={`${style.footer} globalISROOTS`}>
                <div
                    className={classNames(style.scoreHeading, "globalISROOTS")}>
                    主观题打分
                </div>
                <div className={classNames(style.wrapper, "globalISROOTS")}>
                    <div className={classNames(style.comment, "HOME_WORK")}>
                        <div
                            className={style.flexBox}
                            onBlur={() => onChangeScoreAndComment(resultScore)}>
                            <span className={style.label}>得分：</span>
                            <span
                                className={classNames(
                                    style.scoreHide,
                                    "HOME_WORK_LOCK_SHOW"
                                )}>
                                {score}
                            </span>
                            <InputNumber
                                min={0}
                                max={parseFloat(props.score)}
                                placeholder="请输入分数"
                                value={score}
                                onChange={value => setScore(value || 0)}
                                precision={1}
                            />
                        </div>
                        {haveComment && (
                            <div className={classNames(style.flexBox)}>
                                <span className={style.label}>评语：</span>
                                <div className={style.textBox}>
                                    <Input.TextArea
                                        placeholder="请输入评语"
                                        defaultValue={comment}
                                        rows={4}
                                        onBlur={onCommentsChange}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {referenceText.trim() && (
                <div className={style.reference}>
                    <h1 className={style.referenceTitle}>参考答案</h1>
                    <div dangerouslySetInnerHTML={{ __html: referenceText }} />
                </div>
            )}
        </div>
    );
}
